

function dealerWalletManagement() {

    let profileService = [
        {
            name: "Wallet Management",
            icon: "Wallet Management",
            logoName: "fee",
            // flag: "voucherRequired",
            displayService: "dealerWalletManagement",
            items: [],
        },
    ];

    const dashboard = () => {
        const dashboardArr = [
            {
                path: "/index/dealerWalletManagement",
                name: "Dashboard",
                icon: "dashboard",
                logoName: "dashboard",
                flag: "",
            },
        ];

        return dashboardArr;
    };

    // const dsrMaster = () => {
    //     const profileArr = [
    //         {
    //             path: "/index/dsrMaster",
    //             name: "DSR Master",
    //             icon: "fee-master",
    //             logoName: "fee",
    //         },
    //     ];
    //     return profileArr;
    // };

    const walletTransaction = () => {
        const profileArr = [
            {
                path: "/index/walletTransactionDealer",
                name: "Wallet Transaction",
                icon: "fee-master",
                logoName: "wallet transaction",
            },
        ];
        return profileArr;
    };

    const summaryReport = () => {
        const profileArr = [
            {
                path: "/index/summaryReport",
                name: "Summary report",
                icon: "fee-master",
                logoName: "summary report1",
            },
        ];
        return profileArr;
    };

    const feeReport = () => {
        const profileArr = [
            {
                path: "/index/feeReport",
                name: "Fee report",
                icon: "fee-master",
                logoName: "FeeReport",
            },
        ];
        return profileArr;
    };


    let a = dashboard();
    // let b = dsrMaster();
    let b = walletTransaction();
    let c = summaryReport();
    let d = feeReport();

    profileService[0].items = [...a, ...b, ...c, ...d];

    return profileService;
}

export default dealerWalletManagement;
